import axios from 'axios';

const SceneService = {
  /**
   * Obtiene el clima de una instalación
   * y los guardo en el store
   *
   * @param {Object} data - Datos de la instalación
   * @returns {Object} - Clima de la instalación
   */
  // eslint-disable-next-line consistent-return
  async getAppsPrefix() {
    // Request
    const path = 'aprovisionamiento_apps_protocol.json';
    const instance = axios.create({ baseURL: 'https://doc.airzonecloud.com/documents/' });
    const demoData = await instance.get(path, {
      transformRequest: (data, headers) => {
        delete headers.common.Authorization;
        return data;
      },
    });

    const prefixes = {};
    const apps = demoData.data;
    Object.keys(demoData.data).forEach(app => {
      if (app !== 'global') {
        // Genero los prefijos
        demoData.data.global.prefix.forEach(prefixGlobal => {
          demoData.data[app].prefix.forEach(aiddoPrefix => {
            const name = `${prefixGlobal}${aiddoPrefix}`;
            prefixes[name] = app;
          });
        });
      }
    });

    return { prefixes, apps };
  },
};

export default SceneService;
